export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/profile_pic_2.jpg" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills--section--heading">About Me</h1>
          <p className="hero--section-description">
            Hi, I'm Lindsey. I'm a Data Analyst in Austin, TX, with a passion for bridging the gap between business strategy and data-driven insights. After more than a decade in business operations and technical talent strategy, I'm leveraging my new specialization in machine learning and data science to solve complex challenges.
          </p>
          <p className="hero--section-description">
            I'm currently pursuing my M.S. in Data Science from the University of Virginia and hold recent certificates in AI/Machine Learning and Full Stack Development from UT Austin. My experience allows me to see the full picture—I don't just build predictive models with Python, SQL, and Scikit-learn, I understand the "why" behind the data, focusing on stakeholder needs and delivering measurable ROI.
          </p>
          <p className="hero--section-description">
            I'm excited to bring this unique blend of deep business experience and advanced technical skill to a team focused on solving meaningful problems.          </p>
        </div>
      </div>
    </section>
  );
}
